<script setup lang="ts">
defineProps<{ freeShipping?: boolean }>()
</script>

<template>
  <NCard class="group relative overflow-hidden">
    <!-- Image wrapper -->
    <div class="relative h-auto w-full" data-testid="productImage">
      <NSkeleton class="aspect-square h-full w-full flex-grow object-cover" wave shape="rect" />
    </div>

    <div class="flex flex-1 flex-col p2 md:pb2">
      <!-- Product title -->
      <h3 class="line-clamp-1 text-xs" n="xs slate5 dark:slate4">
        <NSkeleton class="w-full" wave />
      </h3>

      <!-- Price section -->
      <div class="flex space-x-1">
        <NSkeleton class="h-5 w-16" wave />
        <NSkeleton class="h-5 w-12" wave />
      </div>

      <!-- Stock availability -->
      <div class="mt-1 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <template v-if="freeShipping || freeShipping != null">
          <NSkeleton class="h-4 w-32" pulse />
        </template>
      </div>

      <!-- Rating section -->
      <div class="mt-1 flex items-center gap-1">
        <Rating :rating="0" class="text-xs xs:text-sm lg:-mt-0.5" />
        <NSkeleton class="h-4 w-8" wave />
      </div>

      <!-- Free shipping section -->
      <div class="mt-1 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <template v-if="freeShipping || freeShipping != null">
          <NSkeleton class="h-4 w-24" pulse />
        </template>
      </div>
    </div>
  </NCard>
</template>
